import { render } from "./tender_header.vue?vue&type=template&id=08787962&scoped=true"
import script from "./tender_header.vue?vue&type=script&lang=js"
export * from "./tender_header.vue?vue&type=script&lang=js"

import "./tender_header.vue?vue&type=style&index=0&id=08787962&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08787962"],['__file',"vue/js/components/contragent/tender/tabs/tender_header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08787962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08787962', __exports__)) {
    console.log('reload')
    api.reload('08787962', __exports__)
  }
  
  module.hot.accept("./tender_header.vue?vue&type=template&id=08787962&scoped=true", () => {
    console.log('re-render')
    api.rerender('08787962', render)
  })

}


export default __exports__